import type { SupportedIdDocType } from '@/idv2/features/collect-document/types';

const docTypeTranslationKeyMap: Partial<Record<SupportedIdDocType, string>> = {
  drivers_license: 'driversLicense',
  id_card: 'idCard',
  passport: 'passport',
  visa: 'visa',
  permit: 'workPermit',
  residence_document: 'residenceDocument',
  voter_identification: 'voterIdentification',
  ssn_card: 'ssnCard',
  lease: 'lease',
  bank_statement: 'bankStatement',
  utility_bill: 'utilityBill',
  proof_of_address: 'proofOfAddress',
  passport_card: 'passportCard',
  custom: 'custom',
};

export default docTypeTranslationKeyMap;
